
// this file is automatically generated by git.version.js script
exports.versions = {
  revision: '3faefe07697257ceb1a81f0a296ad6f7678ab62c',
  branch: 'final',
  version: '1.4.0'
};